<template lang="pug">
uc-lightbox(:id="id" :screen="screen" @close="onClose" block="")
  uc-filter-tags(v-slot="{ filterTags }")
    .page(
      :class="courseCssClasses"
      style="height: 100%; width: 100%; --edge-padding: 1rem"
    )
      uc-scroll-page(:compute-height="true")
        .h-full.w-full.overflow-hidden.corners
          UseCompletables(:ids="lightboxPageId")

          template(
            :key="scr.id"
            v-for="(scr, i) in filterTags(screen.screens)"
          )
            uc-scroll-section.uc-lightbox-page-section(
              :data-audio="scr.audio || scr.speech || null"
              :data-pass-course="scr['pass-course']"
              :id="scr.id"
            )
              audio-marker(:name="scr.id")
              uc-screen(
                :edit-path="editPathScreens ? `${editPathScreens}.${i}` : `${editPath}.screens.${i}`"
                :screen="scr"
              )
                //- toggle, but not first or last screen
              uc-toggle-included(
                :class="{ dark: scr.dark }"
                :id="scr.id"
                v-if="editModeAvailable && scr.screenIndex && scr.screenIndex < screen.screens.length - 1"
              )

              br.hidden(uc-word-only="")

  template(v-slot:buttons="{ close }")
    uc-button.btn.btn-primary(
      :disabled="!completed"
      @click="close"
      data-sfx="complete"
      text="Continue"
      :class="{ 'w-full': !largerThanSm.value }"
    )
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import useEditMode from '../stores/useEditMode';
import { onMounted, watchEffect, inject, computed } from 'vue';
import useSuspend from '../lib/useSuspend';
import { setCompleted } from '../lib/SCORM';
import {
  useCompletables,
  // UseLockables,
  UseCompletables
} from '../stores/useLockables';
import type { UcLightboxPage } from '../../types/ScreenLightbox.d.ts';

const props = defineProps<UcLightboxPage>();

const lightboxPageId = computed(() => `lightboxpage_${props.id}`);
const suspend = useSuspend();
const courseCssClasses = inject('courseCssClasses');
const largerThanSm = inject('largerThanSm');
const { available: editModeAvailable } = storeToRefs(useEditMode());
const completed = computed(() => suspend.completed[lightboxPageId.value]);

useCompletables(lightboxPageId);

// unlock first screen
onMounted(() => setCompleted(props.screen.screens[0].id));

// unlock page when last screen complete
watchEffect(() => {
  const [lastSection] = props.screen.screens.slice(-1);
  if (suspend.completed[lastSection.id]) setCompleted(lightboxPageId.value);
});
</script>
